var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12"}},[_c('h1',{staticClass:"mb-4 mt-2 display-1 text-center"},[_vm._v("Clientes")])]),_c('v-col',{staticClass:"mx-auto white rounded-lg elevation-1",attrs:{"cols":"12","md":"8","xl":"6"}},[_c('clientes-component',{attrs:{"modoLista":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }